module.exports = (__webpack_require__(98593))(42);